module.exports = __webpack_public_path__ + "img/15174b6.jpg";